import { useContext, useState } from 'react'

import Button from '@/components/view/atoms/button/Button'
import ButtonList from '@/components/view/layouts/button/ButtonList'
import Dialog from '@/components/view/molecules/dialog/Dialog'

import { DeleteDialogContext } from './DeleteDialogProvider'

const DeleteDialog = () => {
  const { modal, showing, hide } = useContext(DeleteDialogContext)
  const [loading, setLoading] = useState<boolean>(false)

  const truncatedName = modal.name.length > 20 ? `${modal.name.slice(0, 20)}...` : modal.name

  return (
    <Dialog showing={showing} text={`${truncatedName}を削除します。一度削除すると復元はできません。よろしいですか？`}>
      <ButtonList>
        <Button color={'secondary'} onClick={hide} size='large'>
          キャンセル
        </Button>
        <Button
          size='large'
          color={'critical'}
          onClick={async () => {
            setLoading(true)
            modal.onClickDelete().finally(() => {
              setLoading(false)
            })
          }}
          loading={loading}
        >
          削除する
        </Button>
      </ButtonList>
    </Dialog>
  )
}

export default DeleteDialog
